import { ExtremwetterschutzSelbstbeteiligung } from '@ps20/bff-models';
import { IAppState } from '../../../store/appState';
import { ExtremwetterschutzSelbstbeteiligungValues } from '../../../store/model/extremwetterschutzSelbstbeteiligungValues.model';
import { ZusatzoptionenNameVHVEnum } from '../../../store/model/zusatzoptionenVHV.model';
import { selectSelectedProduktlinie } from './produkt.selector';

export const selectElementarSelbstbehaltId = (state: IAppState): string =>
  state.elementarSelbstbehalt ? state.elementarSelbstbehalt.id : null;

export const selectElementarSelbstbehaltDescription = (state: IAppState): string =>
  state.elementarSelbstbehalt ? state.elementarSelbstbehalt.description : null;

export const selectExtremwetterschutzSelbstbeteiligungChosenValue = (
  state: IAppState,
): ExtremwetterschutzSelbstbeteiligung => state.extremwetterschutzSelbstbeteiligung;

export const selectExtremwetterschutzSelbstbeteiligungValuesList = (
  state: IAppState,
): ExtremwetterschutzSelbstbeteiligungValues[] => {
  return state.transientState?.extremwetterschutzSelbstbeteiligungValuesList;
};

export const selectExtremwetterschutzActiveValue = (
  state: IAppState,
): ExtremwetterschutzSelbstbeteiligung => {
  const isElementarSelected = selectSelectedProduktlinie(state)?.zusatzoptionen?.find(
    zusatzoption => zusatzoption.name === ZusatzoptionenNameVHVEnum.ELEMENTAR,
  )?.isSelected;

  if (!isElementarSelected) {
    return undefined;
  }

  return selectExtremwetterschutzSelbstbeteiligungChosenValue(state);
};
